<!-- 自定义 MessageBox 组件 -->
<template>
  <div class="share-dialog" v-show="isShowMessageBox">
    <!-- <div class="mask" @click="cancel"></div> -->
    <div class="mask"></div>
    <div class="share-dialog-con">
      <div class="close" @click="cancel"><i></i></div>
      <h3 class="header-title">{{ title }}</h3>
      <div class="content">
        <ul>
          <li>
            <a :href="shareLink.facebook" target="_blank" class="share-facebook">
              <img src="../../../../static/img/share/icon-share-big-facebook.png" alt="">
            </a>
          </li>
          <li>
            <a :href="shareLink.twitter" target="_blank" class="share-twitter">
              <img src="../../../../static/img/share/icon-share-big-twitter.png" alt="">
            </a>
          </li>
          <!-- <li>
            <a href="" class="share-ins">
              <img src="../../../../static/img/share/icon-share-big-ins.png" alt="">
            </a>
          </li> -->
          <li>
            <a :href="shareLink.weibo" target="_blank" class="share-weibo">
              <img src="../../../../static/img/share/icon-share-big-weibo.png" alt="">
            </a>
          </li>
          <li class="share-wechat-li">
            <a class="share-wechat" @click="isweixinCode = true">
              <img src="../../../../static/img/share/icon-share-big-wechat.png" alt="">
            </a>
          </li>
          <li>
            <a :href="shareLink.email" target="_blank" class="share-email">
              <img src="../../../../static/img/share/icon-share-big-email.png" alt="">
            </a>
          </li>
          <li>
            <a class="share-copy" @click="copyCurrentLink">
              <img src="../../../../static/img/share/icon-share-big-copy.png" alt="">
            </a>
          </li>
        </ul>
      </div>
      <div class="js-qrcode" :class="{hidden: isweixinCode == false}">
        <span class="qrcode_arr"></span>
        <div class="qrcode_close" title="close" @click="isweixinCode = false"></div>
        <div id="pdlShareQrcode" ref="pdlShareQrcode"></div>
      </div>
      <div class="copyed" :class="{'show':isCopyed}">
        <i></i><span>Copied</span>
      </div>
    </div>
  </div>
</template>
 
<script>
import QRCode from 'qrcodejs2'
  export default {
    props: {
      title: {
        type: String,
        default: '标题'
      },
      content: {
        type: String,
        default: '这是弹框内容'
      },
      link: {
        type: Object,
        default: function(){
          return {};
        }
      },
    },
    computed:{
      params(){ 
        return Object.assign({
          facebook:'123222',
          twitter:'234222',
          weibo:'456222',
          weixin:'567222',
          email:'678222',
        },this.link);
      }
    },
    data () {
      return {
        isShowMessageBox: false,
        shareLink:{},
        isweixinCode:false,
        isCopyed:false,
      };
    },
    watch: {
      link: function(newVal,oldVal){
        this.shareLink = newVal;  //newVal即是chartData
        this.getShareLink();
      }
    },
    methods: {
      // 确定,将promise断定为resolve状态
      confirm: function () {
        this.isShowMessageBox = false;
        // this.remove();
      },
      // 取消,将promise断定为reject状态
      cancel: function () {
        this.isShowMessageBox = false;
        this.isweixinCode = false;
        // this.remove();
      },
      // 弹出messageBox,并创建promise对象
      showMsgBox: function () {
        this.isShowMessageBox = true;
      },
      remove: function () {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      destroy: function () {
        this.$destroy();
        document.body.removeChild(this.$el);
      },
      getShareLink(){
        var _this = this;
        if($('#pdlShareQrcode')){
          $('#pdlShareQrcode').empty();
        }
        _this.qrcode(_this.shareLink.weixin);
      },
      qrcode(url){
        var _url = url , _this = this;
        var pdlShareQrcode = new QRCode('pdlShareQrcode',{
          width: 100, // 设置宽度，单位像素
          height: 100, // 设置高度，单位像素
          text: _url // 设置二维码内容或跳转地址
        })
      },
      copyCurrentLink() {
        let that = this;
        if(!that.isCopyed){
          var input = document.createElement('input');
          // input.value = window.location.href;
          input.value = that.shareLink.weixin
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          that.isCopyed = true;
          setTimeout(()=>{
            that.isCopyed = false;
          },2000)
        }
      },
    },
    created(){

    },
    mounted(){
      
    },
  };
</script>
 
<style scoped lang="scss">
.share-dialog {
  position: relative;
  .mask {
    position: fixed;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50000;
    background: rgba(0, 0, 0, 0.7);
  }
  .share-dialog-con {
    position: fixed;
    box-sizing: border-box;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 50001;
    border-radius: 10px;
    .close {
      position: absolute;
      top: 15px;
      right: 20px;
      width: 20px;
      height: 20px;
      background: url('../../../../static/img/close.png') no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
    }
    .header-title {
      height: 50px;
      font-size: 16px;
      color: #999999;
      font-weight: 400;
      font-family: HelveticaLTPro-Light;
      line-height: 54px;
      text-align: center;
    }
    .content {
      border-top: 1px solid #dddddd;
      padding: 18px 50px;
      ul{
        overflow: hidden;
        clear: both;
        li{
          width: 50px;
          height: 50px;
          margin-left: 52px;
          float: left;
          &:first-child{
            margin-left: 0;
          }
          a{
            display: block;
            cursor: pointer;
          }
        }
      }
    }
    .js-qrcode{
      position: absolute;
      top: 136px;
      padding:15px;
      border: 1px solid #ddd;
      right: 170px;
      background-color: #fff;
      border-radius: 5px;
      &.hidden{
        display: none;
      }
      .qrcode_arr{
        width: 11px;
        height: 7px;
        background: url('../../../../static/img/qrcode_arr.jpg') no-repeat;
        position: absolute;
        top: -7px;
        left: 16px;
      }
      .qrcode_close{
        width: 12px;
        height: 12px;
        background: url('../../../../static/img/qrcode_close.png') no-repeat;
        position: absolute;
        right: 4px;
        top: 3px;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
    .copyed{
      position: absolute;
      top: 122px;
      left: 82%;
      align-items: center;
      background-color: #eee;
      padding: 5px 8px;
      border-radius: 3px;
      display: none;
      opacity: 0;
      transition: all .5s linear;
      &.show{
        display: flex;
        opacity: 1;
      }
      i{
        display: block;
        width: 20px;
        height: 20px;
        background: url('../../../../static/img/right.png') no-repeat;
        background-size: 100% 100%;
      }
      span{
        display: block;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        color: #999999;
        font-weight: 400;
        font-family: HelveticaLTPro-Roman;
        margin-left: 5px;
        color: #000;
      }
    }
  }
}

@media screen and (max-width: 1560px) and (min-width: 1261px){

}

@media screen and (max-width: 1260px) and (min-width: 769px){
  .share-dialog {
    .share-dialog-con {
      width: 680px;
      .content {
        ul{
          li{
            margin-left: 56px;
          }
        }
      }
      .js-qrcode{
        right: 180px;
        top: 136px;
      }
    }
  }
}
@media screen and (max-width: 768px){
  .share-dialog {
    .share-dialog-con {
      width: 20rem;
      .close {
        position: absolute;
        top: .83rem;
        right: 1.11rem;
        width: 1.11rem;
        height: 1.11rem;
        background: url('../../../../static/img/close.png') no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
      .header-title {
        height: 2.78rem;
        font-size: .89rem;
        color: #999999;
        font-weight: 400;
        font-family: HelveticaLTPro-Light;
        line-height: 3rem;
        text-align: center;
      }
      .content {
        border-top: 1px solid #dddddd;
        padding: 1rem;
        ul{
          overflow: hidden;
          clear: both;
          li{
            width: 2.8rem;
            height: 2.8rem;
            margin-left: 1rem;
            float: left;
            &:first-child{
              margin-left: 0;
            }
            &.share-wechat-li{
              display: none;
            }
            a{
              display: block;
              cursor: pointer;
            }
          }
        }
      }
      .js-qrcode{
        display: none !important;
      }
      .copyed{
        top: 6.8rem;
        left: 15.2rem;
        i{
          width: 1rem;
          height: 1rem;
        }
        span{
          height: 1rem;
          line-height: 1rem;
          font-size: .8rem;
          margin-left: .2rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/share-dialog/index.vue